import React from "react";
import GlobalErrorLayout from "./GlobalErrorLayout";

class ErrorBoundary extends React.Component<
    any,
    {
        hasError: boolean;
    }
> {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return <GlobalErrorLayout />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
